import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { HiChevronRight,HiChevronLeft } from 'react-icons/hi'

import { AppWrap, MotionWrap } from '../../wrapper'
import { urlFor, client } from '../../client'
import './Testimonial.scss'

const Testimonial = () => {
    const [brands, setBrands] = useState([])
    const [testimonialss, setTestimonials] = useState([])
    const [currentIndex, setCurrentIndex] = useState(0)

    useEffect(() => {
        const query = '*[_type=="testimonials"]'
        const brandsQuery = '*[_type=="brands"]'

        client.fetch(query).then((data) => {
            setTestimonials(data)
        })

        client.fetch(brandsQuery).then((data) => {
            setBrands(data)
        })
    }, [])

    return <div>Testimonial</div>
}

export default AppWrap(MotionWrap(Testimonial, 'app__testimonial'), 'testimonial', 'app__primarybg')

